export default () => ({
  tutorialSteps: [
    [2, 2],
    [2, 3],
    [2, 1]
  ],
  title: '#01',
  mapStr: `
    --r--
    -r-r-
    -rrr-
    -r-r-
    --r--
  `
})



// WEBPACK FOOTER //
// ./src/levels/tutorial-1.js